import React, { useState, useEffect } from 'react';
import { FlaskRound as Flask } from 'lucide-react';
import facts from '../data/weirdScience.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';

const WeirdScience = () => {
  const [fact, setFact] = useState('');

  const generateNewFact = () => {
    const randomIndex = Math.floor(Math.random() * facts.facts.length);
    setFact(facts.facts[randomIndex]);
  };

  useEffect(() => {
    generateNewFact();
  }, []);

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-indigo-500/20 to-blue-500/20 group-hover:from-indigo-500/30 group-hover:to-blue-500/30 transition-colors">
          <Flask className="h-6 w-6 text-indigo-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">Weird Science Corner</h3>
      </div>
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-indigo-500/5 to-blue-500/5 rounded-lg p-4 min-h-[80px]">
          <p className="text-gray-300 leading-relaxed">{fact}</p>
        </div>
        <div className="flex justify-between items-center text-sm">
          <div className="flex items-center space-x-2">
            <LikeButton type="science" content={fact} />
            <ShareButton 
              title="Check out this weird science fact!"
              text={fact}
            />
          </div>
          <button 
            onClick={generateNewFact}
            className="text-indigo-400 hover:text-indigo-300 transition flex items-center space-x-1 group"
          >
            <span>More Facts</span>
            <span className="transform group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeirdScience;